import {Component, OnInit, Input, ElementRef} from '@angular/core';
import {Station} from '../station/station';
import {HistoryService} from '../history/history.service';
import {Observable} from "rxjs";
import {ChartService} from "./chart.service";
declare var CanvasJS: any;
declare var jQuery: any;

enum ChartType {Day, HalfDay, SixHours, OneHour, Online}

const WS_URL: any = {
  current: 'wss://api-meteo.bm.pl/currentValues',
  average: 'wss://api-meteo.bm.pl/averageValues'
};
const ChartTypes: any = {
  type24h: {
    type: ChartType.Day,
    name: '24h',
    buffor: 73,
    connection_max_delay: 1500,
    timeRange: 'LAST_24_HOURS',
    historyRange: 'LAST_24_HOURS'
  },       // próbka co 20 min
  type12h: {
    type: ChartType.HalfDay,
    name: '12h',
    buffor: 73,
    connection_max_delay: 720,
    timeRange: 'LAST_12_HOURS',
    historyRange: 'LAST_12_HOURS'
  },        // próbka co 10 min
  type6h: {
    type: ChartType.SixHours,
    name: '6h',
    buffor: 71,
    connection_max_delay: 420,
    timeRange: 'LAST_6_HOURS',
    historyRange: 'LAST_6_HOURS'
  },          // próbka co 5 min
  type1h: {
    type: ChartType.OneHour,
    name: '1h',
    buffor: 60,
    connection_max_delay: 90,
    timeRange: 'LAST_1_HOUR',
    historyRange: 'LAST_1_HOUR'
  },           // próbka co minuta
  typeOnline: {
    type: ChartType.Online,
    name: 'online',
    buffor: 240,
    connection_max_delay: 30,
    timeRange: 'LIVE',
    historyRange: 'LAST_5_MINUTES',
  }   // próbka co sekunda
};
const connectionRetryLimit: number = 3;

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {
  isHistorySet: boolean = false;
  isConnectionProblem: boolean = false;
  isConnectionError: boolean = false;
  probes: any = {
    windStrength: [],
    windStrengthMax: [],
    windStrengthAvg: [],
    windStrengthMin: [],
    windDirection: [],
    temperature: []
  };
  windStrengthMaxValue: number = 0;
  chartTypes: any = [
    ChartTypes.type24h,
    ChartTypes.type12h,
    ChartTypes.type6h,
    ChartTypes.type1h,
    ChartTypes.typeOnline
  ];
  activeType: any = ChartTypes.type6h;
  wsConnection: any;
  retryCounter: number = 0;

  @Input() station: Station;

  constructor(private historyService: HistoryService,
              private chartService: ChartService,
              private elementRef: ElementRef) {
  }

  ngOnInit() {
    this.getHistory();
  }

  getHistory(): void {
    if (!this.station) {
      return;
    }

    this.historyService.getHistory(this.station.name, this.activeType.historyRange).subscribe(
      historyData => {

        //noinspection TypeScriptUnresolvedVariable
        historyData.chartProbes.map(probe => {
          this.addProbe(probe);
        });

        this.isHistorySet = true;
        this.drawChart();
        this.openWebSocket();
      },
      error => {
        if (this.retryCounter < connectionRetryLimit) {
          console.error(error);
          this.isConnectionProblem = true;
          this.retryCounter++;
          this.getHistory();
        } else {
          this.isConnectionError = true;
        }
      }
    );
  }

  addProbe(probe: any): void {
    let probeDate = this.chartService.parseDateToJSObject(probe.date);
    let windStrength;

    if (probe.currentWindValue !== undefined) {
      windStrength = this.chartService.convertWindStrength(probe.currentWindValue);
    } else {
      windStrength = this.chartService.convertWindStrength(probe.avgWindValue);
    }

    this.probes.windStrength.push({x: probeDate, y: windStrength});

    if (this.probes.windStrength.length > this.activeType.buffor) {
      this.probes.windStrength.shift();
    }

    if (windStrength > this.windStrengthMaxValue) {
      this.windStrengthMaxValue = Math.ceil(windStrength);
    }

    if (probe.minWindValue !== undefined && probe.maxWindValue !== undefined) {
      let windStrengthMin = this.chartService.convertWindStrength(probe.minWindValue);

      this.probes.windStrengthMin.push({x: probeDate, y: windStrengthMin});

      if (this.probes.windStrengthMin.length > this.activeType.buffor) {
        this.probes.windStrengthMin.shift();
      }

      this.probes.windStrengthAvg.push({x: probeDate, y: windStrength});

      if (this.probes.windStrengthAvg.length > this.activeType.buffor) {
        this.probes.windStrengthAvg.shift();
      }

      let windStrengthMaxOrigin = this.chartService.convertWindStrength(probe.maxWindValue);

      this.probes.windStrengthMax.push({x: probeDate, y: windStrengthMaxOrigin});

      if (this.probes.windStrengthMax.length > this.activeType.buffor) {
        this.probes.windStrengthMax.shift();
      }

      if (windStrengthMaxOrigin > this.windStrengthMaxValue) {
        this.windStrengthMaxValue = Math.ceil(windStrengthMaxOrigin);
      }
    }

    let windDirection = parseInt(probe.windDirection, 10);
    let temperature = parseFloat(probe.temperature);

    if (isNaN(temperature)) {
      temperature = null;
    }

    if (isNaN(windDirection)) {
      windDirection = 0;
    }

    this.probes.windDirection.push({x: probeDate, y: windDirection});

    if (this.probes.windDirection.length > this.activeType.buffor) {
      this.probes.windDirection.shift();
    }

    this.probes.temperature.push({x: probeDate, y: temperature});

    if (this.probes.temperature.length > this.activeType.buffor) {
      this.probes.temperature.shift();
    }
  }

  drawChart(): void {
    this.setChartArrows();
    const chartHeight = (jQuery(document).outerWidth() * 0.62);
    const chart = new CanvasJS.Chart('stationChart', {
      width: jQuery(document).outerWidth(),
      height: chartHeight,
      backgroundColor: '#ffffff',
      axisX: {
        labelFontSize: 10,
        labelFontFamily: "Arial, sans-serif",
        lineColor: '#cccccc',
        lineThickness: 2,
        gridColor: '#dbdbdb',
        gridThickness: 1,
        valueFormatString: "HH:mm"
      },
      legend: {
        horizontalAlign: "left", // "center" , "right"
        verticalAlign: "bottom",  // "top" , "bottom"
        fontSize: 12,
        fontFamily: "'xxii_centar_regularregular', Arial, sans-serif",
        fontColor: "#666666"
      },
      axisY: {
        labelFontSize: 10,
        labelFontFamily: "'xxii_centar_regularregular', Arial, sans-serif",
        suffix: " °C",
        lineColor: '#ff7e00',
        lineThickness: 1,
        gridColor: '#dbdbdb',
        gridThickness: 0,
        maximum: Math.round(this.getTempMaxValue() +5),
        minimum: Math.round(this.getTempMinValue() -5)
      },
      axisY2: {
        labelFontSize: 10,
        labelFontFamily: "'xxii_centar_regularregular', Arial, sans-serif",
        suffix: " knts",
        lineColor: '#005abb',
        lineThickness: 1,
        gridColor: '#dbdbdb',
        gridThickness: 1,
        maximum: Math.round(this.getWindMaxStrengthValue() + 5),
        minimum: 0
      },
      toolTip: {
        enabled: true,
        shared: true
      },
      data: [
        {
          type: "area",
          showInLegend: false,
          name: "Max. siła wiatru",
          color: 'rgba(250,220,220,0.7)',
          markerType: 'none',
          dataPoints: this.probes.windStrengthMax,
          axisYType: "secondary",
          toolTipContent: "{name}: {y} knts"
        },
        {
          type: "area",
          showInLegend: false,
          name: "Śr. siła wiatru",
          color: 'rgba(185,220,255,0.7)',
          markerType: 'none',
          dataPoints: this.probes.windStrengthAvg,
          axisYType: "secondary",
          toolTipContent: "<span class='hiddenbr'>{name}: {y} knts</span>"
        },
        {
          type: "area",
          showInLegend: false,
          name: "Min. siła wiatru",
          color: 'rgba(255,255,255,1)',
          markerType: 'none',
          dataPoints: this.probes.windStrengthMin,
          axisYType: "secondary",
          toolTipContent: "{name}: {y} knts"
        },
        {
          type: "line",
          lineThickness: 1,
          showInLegend: true,
          name: "Siła wiatru",
          legendText: 'siła wiatru',
          color: 'rgba(185,220,255,1)',
          markerType: 'none',
          dataPoints: this.probes.windStrength,
          axisYType: "secondary",
          toolTipContent: "<span>{name}: {y} knts</span>"
        },
        {
          label: "knts",
          type: "line",
          lineThickness: 1,
          showInLegend: false,
          markerType: 'none',
          color: 'rgba(255,80,80,1)',
          dataPoints: this.probes.windStrengthMax,
          axisYType: "secondary",
          toolTipContent: "<span class='hiddenbr'>{name}: {y} knts</span>"
        },
        {
          label: "°C",
          type: "line",
          lineThickness: 1,
          markerType: 'none',
          showInLegend: true,
          name: "Temperatura",
          legendText: 'temperatura',
          color: '#a1cc2d',
          dataPoints: this.probes.temperature,
          toolTipContent: "{name}: {y} °C"
        }
      ]
    });
    chart.render();
    jQuery('#stationChart').css({
      height: chartHeight - 60
    });
    jQuery('.canvasjs-chart-credit').remove();
  }

  onResize(): void {
    console.log('resize');
    jQuery('#stationChart').html('');
    this.drawChart();
  }

  setChartArrows(): void  {
    let i = this.probes.windStrength.length;
    let j = i - 1;

    if (i > 0) {
      let arrowsContainer = jQuery(this.elementRef.nativeElement).find('.windDirectionArrows');
      let arrows = arrowsContainer.find('.wda').first();

      if (arrowsContainer.outerWidth() > 0) {
        let counter = Math.floor(arrowsContainer.outerWidth() / arrows.outerWidth()) -1;
        arrows.detach();
        arrowsContainer.html('');

        for (let x = counter; x >= 0; x--) {
          arrows.clone().appendTo(arrowsContainer);
        }
      }

      arrows = arrowsContainer.find('.wda');
      let arrowsCounter = arrows.length - 1;

      if (arrowsCounter > 0) {
        let shift = Math.round(this.activeType.buffor / arrows.length);

        if (shift <= 1) {
          shift = 1;
        }

        for (let x = 0; x <= arrowsCounter; x++) {
          let arr = arrows[x];
          let index = Math.abs(x - arrowsCounter) * shift;
          let d = 0;
          let y = (j - index) < 0 ? 0 : (j - index);

          if (this.probes.windDirection[y] !== undefined) {
            d = this.chartService.reverseWindDirection(this.probes.windDirection[y].y);
          }

          jQuery(arr).attr('style', 'transform:rotate(' + d + 'deg); ' +
            '-webkit-transform:rotate(' + d + 'deg); ' +
            '-moz-transform:rotate(' + d + 'deg); ' +
            '-o-transform:rotate(' + d + 'deg);');
        }
      }
    }

  }

  setActiveType(event, type: number) {
    event.preventDefault();
    this.activeType = this.chartTypes.filter(typeItem => typeItem.type === type)[0];
    this.closeWebSocket();
    this.resetProbes();
    this.getHistory();
  }

  resetProbes(): void {
    this.probes.windStrength = [];
    this.probes.windStrengthMax = [];
    this.probes.windStrengthAvg = [];
    this.probes.windStrengthMin = [];
    this.probes.windDirection = [];
    this.probes.temperature = [];
    this.windStrengthMaxValue = 0;
  }

  openWebSocket(): void {
    let url = this.activeType.type === ChartType.Online ? WS_URL.current : WS_URL.average;
    this.wsConnection = Observable.webSocket(url);

    this.wsConnection.retry().subscribe(
      (msg: any) => {
        if (msg.chartProbes && msg.chartProbes.length) {
          this.addProbe(msg.chartProbes[0]);
          this.drawChart();
        }
      },
      (err) => console.log(err)
    );

    this.wsConnection.next(JSON.stringify({name: this.station.name, timeRange: this.activeType.timeRange}));

  }

  closeWebSocket(): void {
    if (this.wsConnection && !this.wsConnection.closed) {
      this.wsConnection.complete();
    }
  }

  getTempMinValue(): number {
    return this.probes.temperature.reduce((a, b) => {
      return Math.min(a, b.y);
    }, 0);
  }

  getTempMaxValue(): number {
    return this.probes.temperature.reduce((a, b) => {
      return Math.max(a, b.y);
    }, 0);
  }

  getWindMaxStrengthValue(): number {
    let windProbesArray = [];

    if (this.probes.windStrengthMax.length) {
      windProbesArray = this.probes.windStrengthMax;
    } else {
      windProbesArray = this.probes.windStrength;
    }

    return windProbesArray.reduce((a, b) => {
      return Math.max(a, b.y);
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/chart/chart.component.ts